import React from 'react';
import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2 } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { myApi } from '../../../../../../config/axiosConfig';
import Swal from 'sweetalert2';

// COMPONENTES
import MyAutoCompleteSublabel from '../../../../../../components/inputs/MyAutoCompleteSublabel';
import MyAutoComplete from '../../../../../../components/inputs/MyAutoComplete';

const ModalAgregarUnidad = ({ open, onClose, refresh, cajas, tractores, clientes }) => {

    const catalogoEventos = {

        'SUKARNE': 1,
        'BAFAR': 133,

    }

    return (

        <Dialog
            open={open}
            onClose={onClose}
        >

            {/* HEADER */}

            <DialogTitle sx={{ textAlign: 'center' }}>
                Agregar Unidades
            </DialogTitle>

            {/* BODY */}

            <DialogContent>

                <Formik
                    initialValues={{
                        caja: '',
                        tractor: '',
                        cliente: ''
                    }}
                    validationSchema={Yup.object({
                        caja: Yup.string().required('Selecciona una Caja'),
                        tractor: Yup.string().required('Selecciona un Tractor'),
                        cliente: Yup.string().required('Selecciona un Cliente'),
                    })}
                    onSubmit={async (values, { setSubmitting, resetForm }) => {

                        try {

                            const tractorSplit = values.tractor.split('*');
                            const cajaSplit = values.caja.split('*');

                            const sendData = {

                                tractor: tractorSplit[0],
                                tractor_placas: tractorSplit[1],
                                caja: cajaSplit[0],
                                caja_placas: cajaSplit[1],
                                telematica_cliente: values.cliente,
                                evento: catalogoEventos[values.cliente],

                            }

                            const response = await myApi.post('/telematica/agregar/unidad', sendData);

                            if(response.data.success){

                                setSubmitting(false);
                                resetForm();
                                onClose();
                                refresh();

                                Swal.fire({
                                    icon: 'success',
                                    title: 'Unidad dada de alta',
                                });

                            }

                        } catch(e) {

                            console.log(e);
                            setSubmitting(false);
                            resetForm();

                        }   

                    }}
                >
                {({ handleSubmit }) => (

                    <Form>

                        <Grid2 container spacing={2} marginTop={1}>

                            {/* CLIENTE */}

                            <Grid2 size={12}>

                                <MyAutoComplete
                                    name="cliente"
                                    label="Cliente"
                                    options={clientes}
                                />

                            </Grid2>

                            {/* CAJA */}

                            <Grid2 size={12}>

                                <MyAutoCompleteSublabel
                                    name="caja"
                                    label="Caja"
                                    options={cajas}
                                />

                            </Grid2>

                            {/* TRACTOR */}

                            <Grid2 size={12}>

                                <MyAutoCompleteSublabel
                                    name="tractor"
                                    label="Tractor"
                                    options={tractores}
                                />

                            </Grid2>

                            {/* FOOTER */}

                            <Grid2 size={12}>

                                <DialogActions
                                    sx={{ justifyContent: 'space-between' }}
                                >

                                    <Button 
                                        type="submit" 
                                        variant="contained" 
                                        color="primary"
                                        onClick={handleSubmit}
                                    >
                                        Guardar
                                    </Button>

                                    <Button onClick={onClose}>Cancelar</Button>

                                </DialogActions>

                            </Grid2>

                        </Grid2>

                    </Form>

                )}
                </Formik>

            </DialogContent>

        </Dialog>

    )

}

export default ModalAgregarUnidad